import { useEffect } from 'react';

type Resolution = {
  error: { code: string; message: string } | null;
  jobId: number;
  state: 'completed' | 'failed';
};

interface Params {
  callback: (resolution: Resolution) => void;
  jobId: number | null | undefined;
}

/**
 * Calls `callback` when the `background-job-resolved` CustomEvent fires
 * for the given jobId. Cleans up the event listener on unmount.
 */
const useJobIdResolved = ({ callback, jobId }: Params) => {
  useEffect(() => {
    if (jobId == null) return;

    const handler = (event: Event) => {
      const detail = (event as CustomEvent<Resolution>).detail;
      if (detail.jobId === jobId) {
        callback(detail);
      }
    };

    window.addEventListener('background-job-resolved', handler);

    return () => {
      window.removeEventListener('background-job-resolved', handler);
    };
  }, [jobId, callback]);
};

export default useJobIdResolved;
